import React from "react";
import "./VirasatDefaultHomePage.scss"
import ServiceCard from "../../components/ServiceCard/ServiceCard";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";




const VirasatDefaultServicesPage = ({ components }) => {
    const dispatch = useDispatch()

    const getHeaderComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultServicesPage-subheader":
                return <div className="VirasatDefaultServicesPage-header-des">- {component?.Props?.text} -</div>
            case "VirasatDefaultServicesPage-headertext":
                return <div className="VirasatDefaultServicesPage-header-title">{component?.Props?.header}
                    <div className="VirasatDefaultServicesPage-header-title-hl"> {component?.Props?.highlightedHeader}</div></div>
            default:
                return <div />
        }

    }
    const headerContent = (headerComponent) => {
        return (
            <div
                className="VirasatDefaultServicesPage-header"
                style={{
                    backgroundImage: ` linear-gradient(90.01deg, #192233 29.22%, rgba(82, 69, 69, 0) 169.9%), url(${headerComponent?.Props?.bgSrc})`
                }}>
                <img alt="" src={headerComponent?.Props?.leftSrc} className="VirasatDefaultServicesPage-header-indimg" />
                {sortByOrderAscending(headerComponent?.Components).map((component, key) => {
                    return (
                        getHeaderComponents(component)
                    )
                })}
                <img alt="" src={headerComponent?.Props?.rightSrc} className="VirasatDefaultServicesPage-header-vegimg" />

            </div>
        )
    }
    const getBottomComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultServicesPage-bottom-subheader":
                return <div className="VirasatDefaultServicesPage-bottom-des">- {component?.Props?.text} -</div>
            case "VirasatDefaultServicesPage-bottom-headertext":
                return <div className="VirasatDefaultServicesPage-bottom-title">{component?.Props?.text}</div>
            case "VirasatDefaultServicesPage-bottom-btncont":
                return <div className="VirasatDefaultServicesPage-bottom-btncont">
                    {component?.Components?.map((button, key) => {
                        return (
                            <Button
                                text={button?.Props?.text}
                                width={button?.Props?.width}
                                isBorder={button?.Props?.isBorder}
                                key={key}
                                onClick={() => {
                                    if (button?.Props?.href && button?.Props?.href !== "") {
                                        if (button?.Props?.href?.includes("https://")) {
                                            window.open(button?.Props?.href, '_blank')
                                        } else {
                                            window.location.href = button?.Props?.href && button?.Props?.href !== "" ? button?.Props?.href : "/"
                                        }
                                    }
                                    else {
                                        dispatch(setIsComing(true))
                                    }
                                }} />
                        )
                    })}

                </div>
            default:
                return <div />
        }

    }
    const bottomContent = (bottomComponent) => {
        return (
            <div
                className="VirasatDefaultServicesPage-bottom"
                style={{
                    backgroundImage: ` linear-gradient(90.01deg, #192233 29.22%, rgba(82, 69, 69, 0) 169.9%), url(${bottomComponent?.Props?.bgSrc})`
                }}>
                <img alt="" src={bottomComponent?.Props?.leftSrc} className="VirasatDefaultServicesPage-bottom-indimg" />
                {sortByOrderAscending(bottomComponent?.Components).map((component, key) => {
                    return (
                        getBottomComponents(component)
                    )
                })}
                <img alt="" src={bottomComponent?.Props?.rightSrc} className="VirasatDefaultServicesPage-bottom-vegimg" />

            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "VirasatDefaultServicesPage-header":
                return headerContent(component)
            case "VirasatDefaultServicesPage-container":
                return <div className="VirasatDefaultServicesPage-container">
                    {component?.Data.map((service, key) => {
                        return (
                            <ServiceCard service={service} key={key} />
                        )
                    })

                    }
                </div>
            case "VirasatDefaultServicesPage-bottom":
                return bottomContent(component)
            default:
                return <div />
        }

    }
    return (
        <div className="VirasatDefaultServicesPage"
        >
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )

}
export default VirasatDefaultServicesPage